import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useCart } from '../../context/CartContext';

const Toast = () => {
  const { toast, clearToast } = useCart();

  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          className="fixed bottom-6 right-6 z-50 bg-charcoal text-white p-4 shadow-2xl flex items-start gap-4 max-w-sm w-full md:w-auto min-w-[300px]"
          role="alert"
          aria-live="assertive"
        >
          <div className="bg-ultramarine/20 text-ultramarine p-2 rounded-full shrink-0">
            <SafeIcon icon={FiIcons.FiCheck} className="text-lg" />
          </div>
          <div className="flex-grow pt-0.5">
            <h4 className="text-[11px] font-bold uppercase tracking-widest mb-1">{toast.title}</h4>
            <p className="text-sm text-gray-300">{toast.message}</p>
          </div>
          <button 
            onClick={clearToast}
            className="text-gray-400 hover:text-white transition-colors p-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ultramarine"
            aria-label="Close notification"
          >
            <SafeIcon icon={FiIcons.FiX} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;